import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { SIZES } from '../Common/constants';

import SearchIcon from 'dibs-icons/exports/MagnifyingGlass';
import { StyledButton } from '../Common/Button/StyledButton';

// styles
import styles from './main.scss';

const { small, medium, large } = SIZES;

type ButtonProps = {
    dataTn: string;
    disabled?: boolean;
    hideClearButton?: boolean;
    size: typeof small | typeof medium | typeof large;
};

export const LeftSearchButton: FunctionComponent<ButtonProps> = ({
    dataTn,
    disabled = false,
    hideClearButton = true,
    size,
}) => {
    // default to medium size
    let sizeSearch = styles.mediumSearch;
    if (size === 'small') {
        sizeSearch = styles.smallSearch;
    } else if (size === 'large') {
        sizeSearch = styles.largeSearch;
    }
    const searchButtonClasses = classNames(styles.fullyTransparent, {
        [styles.defaultSearch]: !size,
        [sizeSearch]: !!size,
        [styles.noClick]: hideClearButton,
    });

    const buttonProps = {
        className: searchButtonClasses,
        dataTn,
        disabled,
        isPrimary: false,
        tabIndex: -1,
    };

    return (
        <StyledButton type="submit" {...buttonProps}>
            <SearchIcon />
        </StyledButton>
    );
};
